import { render, staticRenderFns } from "./chat-indice-mensagens.vue?vue&type=template&id=055b9c4c&scoped=true&"
import script from "./chat-indice-mensagens.vue?vue&type=script&lang=js&"
export * from "./chat-indice-mensagens.vue?vue&type=script&lang=js&"
import style0 from "./chat-indice-mensagens.vue?vue&type=style&index=0&id=055b9c4c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b9c4c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055b9c4c')) {
      api.createRecord('055b9c4c', component.options)
    } else {
      api.reload('055b9c4c', component.options)
    }
    module.hot.accept("./chat-indice-mensagens.vue?vue&type=template&id=055b9c4c&scoped=true&", function () {
      api.rerender('055b9c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-indice-mensagens/chat-indice-mensagens.vue"
export default component.exports